<template>
  <v-flex xs12 sm6 d-flex>
    <v-layout column>
      <v-flex>
        <v-text-field
          v-model="minAmount"
          label="Valor mínimo"
          type="number"
          step="0.01"
          min="0"
          prefix="R$"
        ></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field
          v-model="maxAmount"
          label="Valor máximo"
          type="number"
          step="0.01"
          min="0"
          prefix="R$"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Amount',
  computed: {
    minAmount: {
      get() {
        return this.filtersMinAmount;
      },
      set(value) {
        this.$store.dispatch('payments/setMinAmount', value);
      },
    },
    maxAmount: {
      get() {
        return this.filtersMaxAmount;
      },
      set(value) {
        this.$store.dispatch('payments/setMaxAmount', value);
      },
    },
    ...mapGetters({
      filtersMinAmount: 'payments/filtersMinAmount',
      filtersMaxAmount: 'payments/filtersMaxAmount',
    }),
  },
};
</script>